import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';

class ErrorBoundary extends Component {
    state = {hasError: false};

    componentDidCatch(error, info) {
        // Display fallback UI
        this.setState({hasError: true});
        // You can also log the error to an error reporting service
        console.log(error);
        console.log(info);
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <Redirect to="/signup/"/>
            )
        } else {
            return this.props.children;
        }
    }

}

export default ErrorBoundary;